import { fromJS, Map } from 'immutable';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export class BannerTrackingObject implements ITrackingObject {
  private _props: Map<string, any>;

  constructor(props?: any) {
    this._props = props && props.toMap ? props.toMap() : fromJS(props || {});
  }

  get name() {
    return TrackingObjectNamesEnum.banner;
  }

  get properties() {
    return this._props.toJS();
  }
}
